export const CUSTOMER_AGENT_VOICE = 'CUSTOMER_AGENT_VOICE';
export const CUSTOMER_AGENT_VOICE_CHANNEL_SETTINGS = 'CUSTOMER_AGENT_VOICE_CHANNEL_SETTINGS';
export const UNKNOWN_SOURCE = 'UNKNOWN_SOURCE';

/**
 * All Media sources that are supported by the media player.
 */